var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,52H25c-.2651,0-.5195-.1055-.707-.293l-3.707-3.707h-7.5859c-.5522,0-1-.4473-1-1v-7h-2v3c0,.5527-.4478,1-1,1H5c-.5522,0-1-.4473-1-1v-12c0-.5527,.4478-1,1-1h4c.5522,0,1,.4473,1,1v3h2v-7c0-.5527,.4478-1,1-1h4.4648l3.7031-5.5547c.1855-.2783,.4976-.4453,.832-.4453h7v-2h-3c-.5522,0-1-.4473-1-1v-4c0-.5527,.4478-1,1-1h12c.5527,0,1,.4473,1,1v4c0,.5527-.4473,1-1,1h-3v2h9c.334,0,.6465,.167,.832,.4453l3.7031,5.5547h2.4648c.5527,0,1,.4473,1,1v6h2v-3c0-.5527,.4473-1,1-1h4c.5527,0,1,.4473,1,1v14c0,.5527-.4473,1-1,1h-4c-.5527,0-1-.4473-1-1v-3h-2v6c0,.2656-.1055,.5195-.293,.707l-4,4c-.1875,.1875-.4414,.293-.707,.293Zm-21.5859-2h21.1719l3.4141-3.4141v-6.5859c0-.5527,.4473-1,1-1h4c.5527,0,1,.4473,1,1v3h2v-12h-2v3c0,.5527-.4473,1-1,1h-4c-.5527,0-1-.4473-1-1v-6h-2c-.334,0-.6465-.167-.832-.4453l-3.7031-5.5547h-9.4648c-.5527,0-1-.4473-1-1v-4c0-.5527,.4473-1,1-1h3v-2h-10v2h3c.5522,0,1,.4473,1,1v4c0,.5527-.4478,1-1,1h-7.4648l-3.7031,5.5547c-.1855,.2783-.4976,.4453-.832,.4453h-4v7c0,.5527-.4478,1-1,1h-4c-.5522,0-1-.4473-1-1v-3h-2v10h2v-3c0-.5527,.4478-1,1-1h4c.5522,0,1,.4473,1,1v7h7c.2651,0,.5195,.1055,.707,.293l3.707,3.707Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "a`"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/Engine.72a6c39b6c073ab4732da67147db581f.svg";
export { ForwardRef as ReactComponent };